(() => {
  // Tabs
  (function regimeTabsInit() {
    var groupElements = document.querySelectorAll('[data-regime-tab-group]');

    var buttonAttribute = 'data-regime-tab-button';

    var panelAttribute = 'data-regime-tab-panel';

    var isActiveClass = 'is-active';

    groupElements.forEach(groupElement => {
      var buttonElements = groupElement.querySelectorAll(
        `[${buttonAttribute}]`
      );

      var panelElements = groupElement.querySelectorAll(`[${panelAttribute}]`);

      groupElement.addEventListener('click', event => {
        if (!event.target.matches(`[${buttonAttribute}]`)) return;

        var buttonElement = event.target;

        var buttonId = buttonElement.getAttribute(buttonAttribute);

        var activePanelElements = groupElement.querySelectorAll(
          `[${panelAttribute}='${buttonId}']`
        );

        [...buttonElements, ...panelElements].forEach(buttonOrPanelElement => {
          buttonOrPanelElement.classList.remove(isActiveClass);

          if (buttonOrPanelElement.ariaSelected) {
            buttonOrPanelElement.ariaSelected = 'false';
          }

          if (buttonOrPanelElement.ariaHidden) {
            buttonOrPanelElement.ariaHidden = 'true';
          }
        });

        if (activePanelElements.length) {
          activePanelElements.forEach(activePanelElement => {
            activePanelElement.classList.add(isActiveClass);
            activePanelElement.ariaHidden = 'false';
          });
        }

        buttonElement.classList.add(isActiveClass);
        buttonElement.ariaSelected = 'true';
      });
    });
  })();

  // Menu select

  (function regimeMenuSelectInit() {
    var selectElement = document.querySelector('styled-select');
    if (selectElement) {
      selectElement.addEventListener('change', () => {
        var select = selectElement.querySelector('select');
        location = select.value;
      });
    }
  })();

  // Product form

  (function regimeProductFormInit() {
    var containerAttribute = 'data-regime-product-form-container';

    var containerElements = document.querySelectorAll(
      `[${containerAttribute}]`
    );

    containerElements.forEach(containerElement => {
      var containerData = JSON.parse(
        containerElement.getAttribute(containerAttribute)
      );

      var formElement = containerElement.querySelector(
        '[data-regime-product-form]'
      );

      var priceElement = containerElement.querySelector(
        '[data-regime-product-form-price]'
      );

      var imageElement = containerElement.querySelector(
        '[data-regime-product-form-image]'
      );

      var quickviewAttribute = 'data-regime-product-form-quickview';

      var quickviewProductAttribute = 'data-product';

      var quickviewElement = containerElement.querySelector(
        `[${quickviewAttribute}]`
      );

      let reChargeWidget = false;

      window.addEventListener('ReChargeWidget-loaded', () => {
        const reChargeWidgetConfig = {
          productId: containerData.product.id,
          injectionParent: `[data-regime-product-form-recharge][data-form-id="${containerData.formId}"]`,
          selectors: {
            variant: ['.regime-product-card__select'],
          },
        };

        reChargeWidget =
          window.ReChargeWidget.createWidget(reChargeWidgetConfig);

        let count = 0;
        const checkWidgetRendered = setInterval(() => {
          count++;
          if (reChargeWidget.isRendered) {
            clearInterval(checkWidgetRendered);

            containerElement
              .querySelector('[data-regime-product-form-price]')
              .classList.add('hide');

            const rechargeContainer = document.querySelector(
              `[data-form-id=${containerData.formId}]`
            );

            insertRechargeCompareSpan(rechargeContainer, 'onetime');
            insertRechargeCompareSpan(rechargeContainer, 'subsave');

            const variantId = rechargeContainer
              .closest('form')
              .querySelector('select').value;

            const initialVariant = containerData.product.variants.find(
              v => v.id == variantId
            );

            if (initialVariant) {
              updateMdpRegimeSubscriptionPricing(
                initialVariant,
                rechargeContainer
              );
            }

            // listen for and react to recharge widget option change
            const rcWidgetOptions =
              rechargeContainer.querySelectorAll('.rc-option');

            rcWidgetOptions.forEach(option => {
              option.addEventListener(
                'click',
                e =>
                  e.target.value &&
                  updateAtcPriceBoxFromSubs(
                    e,
                    rechargeContainer.closest('form')
                  )
              );
            });
          }

          // prevent interval repeating forever
          if (count === 40) {
            clearInterval(checkWidgetRendered);
            console.error('The recharge widget did not render in time');
          }
        }, 100);
      });

      formElement.addEventListener('change', async () => {
        // Get selected selling plan from active recharche dropdown and update data atribute on form element!

        if (
          formElement.querySelector(
            '.rc_widget__option--subsave.rc-option--active'
          )
        ) {
          formElement.setAttribute(
            'data-selling-plan',
            formElement.querySelector('.rc-selling-plans__dropdown').value
          );
        } else {
          formElement.removeAttribute('data-selling-plan');
        }

        var variant = containerData.product.variants.find(
          variant => variant.id == formElement.id.value
        );

        if (!variant) return;

        // update variant.id on button to ensure correct variant is added via 'add all to bag'
        formElement
          .querySelector('.regime-product-card__submit')
          .setAttribute('data-variant-id', variant.id);

        // add / upd compare-at price in ATC element
        priceElement.querySelector('s')?.remove();
        if (variant.compare_at_price) {
          const prePriceElement = document.createElement('s');
          prePriceElement.className = 'price-v2-pdp price-v2__pre-pdp';
          prePriceElement.setAttribute('aria-hidden', 'true');
          prePriceElement.setAttribute('compare-at', variant.compare_at_price);
          prePriceElement.textContent = formatPrice(
            containerData.currencySymbol,
            variant.compare_at_price
          );

          priceElement.insertBefore(prePriceElement, priceElement.firstChild);
        }

        priceElement.querySelector('span').textContent = formatPrice(
          containerData.currencySymbol,
          variant.price
        );

        if (reChargeWidget) {
          // Snapshot + clear the raw-price cache BEFORE the widget re-renders for
          // the new variant, so updateMdpRegimeSubscriptionPricing below re-caches
          // the new variant's true raw price instead of reusing the previous
          // variant's cached one.
          const pricesBeforeSync = window.getRcWidgetPrices?.(() => formElement);
          window.clearMdpRawPriceCache?.(() => formElement);

          reChargeWidget.state.selectedVariantId = variant.id;
          reChargeWidget.store.dispatch(
            'setSelectedVariantId',
            reChargeWidget.state.selectedVariantId
          );
          reChargeWidget.syncVariant();

          // apply compare-at only to onetime box. Adding a compare-at to subs box
          // will confuse, as unclear what this figure represents - is it compare, non sub price, etc?
          formElement.querySelector('s.compare-at--onetime').textContent =
            variant.compare_at_price
              ? formatPrice(containerData.currencySymbol, variant.compare_at_price)
              : '';

          // syncVariant()'s own re-render is async and not awaitable directly -
          // wait for the widget's displayed price to actually settle on the new
          // variant before reading/discounting it below, or a faster-than-render
          // variant switch would read stale text left over from the previous one.
          // pollMs=30: regime cards want quicker feedback than the 100ms default.
          await window.waitForRcWidgetRefresh?.(() => formElement, pricesBeforeSync, 2000, 30);
        }

        const priceV2Span = formElement.querySelector(
          'span.price-v2__actual-pdp'
        );
        updateVariantData(variant.id, priceV2Span);

        updateMdpPriceV2(variant, priceV2Span);
        updateMdpRegimeSubscriptionPricing(variant, formElement);

        if (imageElement && variant.featured_image?.src) {
          imageElement.src = imageElement.srcset = variant.featured_image.src;
        }

        if (quickviewElement) {
          var quickviewValue = `${
            quickviewElement
              .getAttribute(quickviewProductAttribute)
              .split('?')[0]
          }?variant=${variant.id}`;

          quickviewElement.setAttribute(
            quickviewProductAttribute,
            quickviewValue
          );
        }
      });
    });

    function formatPrice(currencySymbol, priceData) {
      if (!priceData) return null;

      let priceFloat = priceData / 100;

      let price = Number.isInteger(priceFloat)
        ? `${currencySymbol}${priceFloat}`
        : Shopify.formatMoney(priceData, `${currencySymbol}{{ amount }}`);

      return price;
    }

    // On variant change, keep the priceV2 span's price-v2__<variantId> class in
    // sync, so other code keying off that class (e.g. the mdp price patch below)
    // targets the right variant.
    function updateVariantData(variantId, priceV2Span) {
      // rm existing 'price-v2__<variantId>` class
      const classToRemove = [...priceV2Span.classList].find(
        className =>
          className.startsWith('price-v2__') &&
          /^\d+$/.test(className.slice(10))
      );
      if (classToRemove) priceV2Span.classList.remove(classToRemove);

      priceV2Span.classList.add(`price-v2__${variantId}`);
    }

    // On variant change, update the priceV2 span with the active mdp discount -
    // mirrors the legacy SitewidePriceHandler#updateRegimePriceV2 patch, but reads
    // shop.metafields.mdp instead of window.progressBarTieredDiscountsData.
    function updateMdpPriceV2(variant, priceV2Span) {
      if (!window.resolveMdpVariantPrice || !priceV2Span) return;

      const { isDiscounted, finalPriceCents } = window.resolveMdpVariantPrice({
        productId: containerData.product.id,
        variantId: variant.id,
        priceCents: variant.price,
        compareAtPriceCents: variant.compare_at_price || 0,
      });

      let pricePreEl = priceV2Span.previousElementSibling;

      if (isDiscounted) {
        const originalPriceCents =
          variant.compare_at_price > variant.price
            ? variant.compare_at_price
            : variant.price;

        if (!pricePreEl) {
          pricePreEl = document.createElement('s');
          pricePreEl.className = 'price-v2-pdp price-v2__pre-pdp';
          pricePreEl.setAttribute('aria-hidden', 'true');
          priceV2Span.insertAdjacentElement('beforebegin', pricePreEl);
        }

        pricePreEl.textContent = formatPrice(
          containerData.currencySymbol,
          originalPriceCents
        );
      } else if (pricePreEl) {
        pricePreEl.remove();
      }

      priceV2Span.textContent = formatPrice(
        containerData.currencySymbol,
        finalPriceCents
      );
    }

    // Re-applies the active mdp discount to the regime card's Recharge widget
    // price nodes - mirrors the legacy
    // SitewidePriceHandler#updateRegimeSubscriptionPricing patch, but reads
    // shop.metafields.mdp instead of window.progressBarTieredDiscountsData. Unlike
    // the legacy sitewideTier.discountSubs flag, mdp discounts have no "exclude
    // subscription price" toggle, so onetime and subsave prices are always
    // discounted together when an mdp discount applies to this variant/product.
    //
    // Always discounts from each node's cached RAW (undiscounted) price
    // (dataset.mdpRawPriceCents), never from whatever text is currently
    // displayed - callers are expected to have already cleared that cache
    // (clearMdpRawPriceCache) and waited for the widget's re-render to settle
    // (waitForRcWidgetRefresh) after a variant switch, or this would re-read an
    // already-discounted price left over from the previous variant and
    // compound the discount on every call.
    function updateMdpRegimeSubscriptionPricing(variant, src) {
      if (!window.resolveMdpDiscountValue) return;

      const discountValue = window.resolveMdpDiscountValue(
        containerData.product.id,
        variant.id
      );

      if (!discountValue) return;

      const multiplier = 1 - discountValue / 100;

      ['onetime', 'subsave'].forEach(priceTypeSuffix => {
        const subscriptionPrices = src.querySelectorAll(
          `.rc_widget__price--${priceTypeSuffix}`
        );

        subscriptionPrices.forEach(subscriptionPrice => {
          const storedRawCents = Number(subscriptionPrice.dataset.mdpRawPriceCents);
          const currentPriceCents =
            storedRawCents || window.parseMdpMoneyToCents(subscriptionPrice.textContent);

          if (!storedRawCents) {
            subscriptionPrice.dataset.mdpRawPriceCents = String(currentPriceCents);
          }

          subscriptionPrice.textContent = formatPrice(
            containerData.currencySymbol,
            Math.round(currentPriceCents * multiplier)
          );

          const formEl = subscriptionPrice.closest('form');
          const shopifySubmitCompareAt = formEl
            ?.querySelector('.regime-product-card__submit s.price-v2-pdp')
            ?.getAttribute('compare-at');

          // Unlike recharge-variant-sync.js's sibling patch, this always
          // overwrites prevPrice rather than only filling it when empty: this
          // node is the <s> insertRechargeCompareSpan created once (empty) at
          // widget load - Recharge itself never populates or recreates it, so
          // it has to be refreshed here on every sync or it'd stay frozen at
          // whatever the first-synced variant's compare-at was.
          const prevPrice = subscriptionPrice.previousElementSibling;
          const compareAtCents = shopifySubmitCompareAt
            ? Number(shopifySubmitCompareAt)
            : currentPriceCents;

          if (prevPrice) {
            prevPrice.textContent = formatPrice(
              containerData.currencySymbol,
              compareAtCents
            );
          }
        });
      });
    }
  })();
})();

class regimeToolbar extends HTMLElement {
  constructor() {
    super();
    this.regimeTabs = document.querySelector('[data-regime-tab-group]');
    this.cartButton = document.querySelector('.js-cart-toggle');
    this.submitButton = this.querySelector('[js-submit]');
    this.submitButton.addEventListener('click', () => this.handleSubmit());
  }

  async handleSubmit() {
    const activeTabs = [
      ...this.regimeTabs.querySelectorAll('.regime-product-cards.is-active'),
    ];
    const submitButtons = activeTabs.flatMap(tabGroup => [
      ...tabGroup.querySelectorAll(
        '.regime-product-cards.is-active [data-regime-product-form-submit]'
      ),
    ]);

    this.submitButton.classList.add('btn--loading');

    let formData = {
      items: [],
    };

    let oosItems = [];

    for (const button of submitButtons) {
      if (button.disabled) {
        let oosItem = {
          title: button.closest('.regime-product-card')?.querySelector('.regime-product-card__title')?.textContent || '',
          image: button.closest('.regime-product-card')?.querySelector('.regime-product-card__image')?.querySelector('.block-rel')?.innerHTML || '',
          price: button.querySelector('[data-regime-product-form-price] span')?.textContent || '',
        };

        oosItems.push(oosItem);
      };

      if (!button.disabled) {
        let sellingPlan;

        if (button.form.getAttribute('data-selling-plan')) {
          sellingPlan = button.form.getAttribute('data-selling-plan');
        } else {
          sellingPlan = '';
        }

        let newItem = {
          id: button.getAttribute('data-full-size-id'),
          quantity: 1,
          selling_plan: sellingPlan,
        };

        if (!formData.items.find(item => item.id === newItem.id)) {
          formData.items.push(newItem);
        }
      }
    }

    const addAllToCart = async () => {
      const globalCart = await new GlobalCart();
      globalCart
        .addToCart(formData, false)
        .then(response => {
          this.submitButton.classList.remove('btn--loading');
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }

    if (oosItems.length > 0) {
      this.submitButton.classList.remove('btn--loading');

      const modal = new ModalBox({
          content: `<h2 class="h2--secondary">${window.regimeStrings.outOfStockTitle}</h2><div class="regime-modalbox__content">${window.regimeStrings.outOfStockDescription}:</div><div class="regime-modalbox__items">${oosItems.map(item => `<div class="regime-modalbox__item"><div class="regime-modalbox__image">${item.image}</div><div><span>${item.title}</span>${item.price}</div></div>`).join('')}</div><div class="regime-modalbox__buttons"><button class="btn btn--large js-buy-in-stock">${window.regimeStrings.addAvailableItems}</button><a href="/pages/regime-guides" class="btn btn--outline btn--large">${window.regimeStrings.backToRegimeGuides}</a></div>`,
          settings: {
            containerCloseButton: true,
            flexClass:'regime-modalbox',
          }
        });

      modal.open(); 

      document.querySelector('.js-buy-in-stock')?.addEventListener('click', () => {
        addAllToCart();
        modal.close()
      });
      return;
    }

    addAllToCart();
  }
}
window.customElements.define('regime-toolbar', regimeToolbar);

// Fixes issue with duplicate ReCharge forms
window.addEventListener('load', () => {
  setTimeout(() => {
    const rechargeFormLabels = document.querySelectorAll('.rc-radio__label');
    rechargeFormLabels.forEach(label => {
      label.addEventListener('click', event => {
        event.preventDefault();
        const labelInput =
          event.currentTarget.parentNode.querySelector('input');
        labelInput.click();
      });
    });
  }, 1500);
});

// Fixes issue with sywm not removing swym-added class as it should
class swymButton extends HTMLElement {
  constructor() {
    super();
    // Fixes issue with swym adding added class to multiple wishlist buttons
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          this.classList.toggle(
            'swym-added-on-load',
            this.classList.contains('swym-added')
          );
          if (this.classList.contains('swym-loaded')) observer.disconnect();
        }
      });
    });
    observer.observe(this, { attributes: true });

    this.addEventListener('click', this.clickHandler.bind(this));
  }

  clickHandler() {
    const classCondition =
      this.classList.contains('swym-adding') &&
      !this.classList.contains('swym-removed');
    this.classList.toggle('swym-removed', classCondition);
    this.classList.remove('swym-added-on-load');
  }
}
window.customElements.define('swym-button', swymButton);

// Select boxes into drop downs
class StyledSelect extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.select.style.display = 'none';
    this.renderDropdown();
  }

  renderDropdown() {
    this.dropdown = document.createElement('div');
    this.dropdown.classList.add('styled-select-menu');
    this.dropdown.setAttribute('aria-labelledby', 'styled-dropdown-button');

    const contentContainer = document.createElement('div');
    contentContainer.classList.add('styled-select-menu__content');

    if ([...this.select.children].some(child => child.tagName === 'OPTGROUP')) {
      [...this.select.children].forEach(option => {
        if (option.tagName === 'OPTGROUP') {
          const group = document.createElement('h3');
          group.textContent = option.label;
          contentContainer.appendChild(group);

          Array.from(option.children).forEach(opt => {
            const button = this.createButton(opt);
            contentContainer.appendChild(button);
          });
        }
      });
    } else {
      [...this.select.children].forEach(option => {
        if (option.tagName === 'OPTION') {
          const button = this.createButton(option);
          contentContainer.appendChild(button);
        }
      });
    }

    this.dropdown.appendChild(contentContainer);

    this.dropdownButton = document.createElement('button');
    this.dropdownButton.classList.add('styled-dropdown__toggle');
    this.dropdownButton.id = 'styled-dropdown-button';
    this.dropdownButton.ariaHasPopup = 'true';
    this.dropdownButton.ariaExpanded = 'false';
    this.selectedOption =
      this.select.options[this.select.selectedIndex].textContent;
    this.dropdownButton.textContent = this.selectedOption.trim();
    this.appendChild(this.dropdownButton);
    this.dropdownButton.addEventListener('click', () => this.toggleDropdown());

    this.appendChild(this.dropdown);

    document.addEventListener('click', event => {
      if (!this.dropdownButton.contains(event.target)) {
        this.dropdown.classList.remove('open');
        this.dropdownButton.ariaExpanded = 'false';
      }
    });
  }

  createButton(option) {
    const button = document.createElement('button');
    button.textContent = option.textContent;
    button.value = option.value;
    if (option.selected) button.classList.add('selected');
    button.addEventListener('click', () => {
      this.select.value = option.value;
      this.dispatchEvent(new Event('change'));
      this.selectedOption = option.textContent;
      this.dropdownButton.textContent = this.selectedOption.trim();
      this.toggleDropdown();
    });
    return button;
  }

  toggleDropdown() {
    this.dropdown.classList.toggle('open');

    if (
      this.dropdown.classList.contains('open') &&
      this.dropdown.querySelector('button')
    ) {
      this.dropdown.querySelector('button').focus();
    }

    if (this.dropdownButton.ariaExpanded == 'true') {
      this.dropdownButton.ariaExpanded = 'false';
    } else {
      this.dropdownButton.ariaExpanded = 'true';
    }
  }
}

/**
 * Builds and inserts a comparison price span element next to the price span within a given container.
 *
 * @param {HTMLElement} container - The container element where the price span is located.
 * @param {string} classSuffix - A suffix to distinguish different price span elements.
 */
function insertRechargeCompareSpan(container, classSuffix) {
  let priceSpan = container.querySelector(`.rc_widget__price--${classSuffix}`);
  priceSpan.style = 'margin-left: 10px';

  const compareSpan = document.createElement('s');
  compareSpan.className = `rc_widget__price compare-at--${classSuffix} f-w400`;
  priceSpan.parentNode.insertBefore(compareSpan, priceSpan);
}

/**
 * Updates the "Add to Cart" (ATB) price box with the pre-discount and actual prices
 * from the subscriptions widget based on the selected subscription type.
 * Whilst subs are active, this will never be visible, but it keeps everything in sync.
 *
 * @param {Event} event - The change event triggered by the subscription type input selection.
 * @param {Document|HTMLElement} [src] - The element to query from for price box elements.
 *
 */
function updateAtcPriceBoxFromSubs(event, src = document) {
  if (event.target.tagName !== 'INPUT') return;

  const subsType = event.target.value;
  const pricePre = event.target
    .closest('.rc-widget')
    .querySelector(`s.compare-at--${subsType}`).textContent;
  const priceActual = event.target
    .closest('.rc-widget')
    .querySelector(`span.rc_widget__price--${subsType}`).textContent;

  const priceBox = src.querySelector('.regime-product-card__submit');

  setTimeout(() => {
    priceBox.querySelector('s.price-v2__pre-pdp') &&
      (priceBox.querySelector('s.price-v2__pre-pdp').textContent = pricePre);
    priceBox.querySelector('span.price-v2__actual-pdp').textContent =
      priceActual;
  }, 0);
}

window.customElements.define('styled-select', StyledSelect);
